import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../components/common/utils/handleError.component';
import { SessionStorageService } from "ngx-webstorage";
import { ClienteLogin, ClienteXCiudad, Cliente } from '../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { LocalData } from 'ng2-completer/services/local-data';
import { UtilService } from '../../components/common/utils/util.service';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos } from '../../components/common/utils/entities/util_entity';
import { ActasService } from './actas.service';
import { FormulariosService } from '../formularios/formularios.service';



const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'actas',
    templateUrl: 'actas.template.html'
})
export class ActasComponent implements OnInit {    
    usuarioEmpresa: ClienteXCiudad;
    consulta: ConsultaCarpeta;
  
    carpetas: Carpeta[];
    showLoader: string;
    showLoaderTabla: string;    
    filterQuery: string;  
    archivosXCliente: Archivo[];
    datosBusqueda: BuscaArchivos;
    datosBusquedaXCliente: BuscaArchivos;
    rutaArmada: string;
    nombreCliente: string;
    nombreSegmento: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private actasService: ActasService,
        public utilsService: UtilService,
        private formulariosService: FormulariosService,
        public sesionStorageService: SessionStorageService,
        private completerService: CompleterService
    ) {      
        this.carpetas = new Array<Carpeta>();
        this.archivosXCliente = new Array<Archivo>();
        this.datosBusqueda = new BuscaArchivos();
        this.datosBusquedaXCliente = new BuscaArchivos();
        this.rutaArmada = "";
        this.nombreCliente = "";

    }
    ngOnInit(): void {
        this.consulta = new ConsultaCarpeta();
        this.showLoader = "sk-loading";
       
        
        try {
            this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        } catch (e) {
            this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioempresa");
        }
        if (this.usuarioEmpresa != null) {
            this.consulta.Carpeta = 3;
            this.consulta.Empresa = this.usuarioEmpresa;
            this.consulta.Masivos = null;
            this.datosBusquedaXCliente.Carpeta = 3;
            this.datosBusquedaXCliente.CodigoCiudad = this.consulta.Empresa.Ciudad;
            this.datosBusquedaXCliente.CodigoCliente = this.consulta.Empresa.CodigoCliente;
            this.datosBusquedaXCliente.CodigoUnidad = this.consulta.Empresa.CodigoUnidad;
            this.datosBusquedaXCliente.NombreCliente = this.consulta.Empresa.Nombre;
        }
        if (this.usuarioEmpresa != null) {
            this.consulta.Carpeta = 1;
            this.consulta.Empresa = this.usuarioEmpresa;
            this.consulta.Masivos = null;
            //this.banderaMasivos = false;
            this.datosBusqueda.Carpeta = 1;
            this.datosBusqueda.CodigoCiudad = this.consulta.Empresa.Ciudad;
            this.datosBusqueda.CodigoCliente = this.consulta.Empresa.CodigoCliente;

        }
       
        
       
            this.formulariosService.getCarpetasPorSegmento(this.consulta).subscribe(
                result => {
                    this.carpetas = result;
                    this.carpetas.forEach(a => {
                        a.ClaseIcono = "fa-folder";
                    });
                    this.showLoader = "";
                },
                error => {
                    this.handleError.redirectUrl(error);
                    this.showLoader = "";
                });
    }


getArchivoClienteSegmento(carpeta: Carpeta){
    this.consulta.Empresa.Unidades.forEach(a =>{
       // console.log(carpeta);
        if(a.Segmento==carpeta.Codigo){
           // console.log(a);
           this.nombreSegmento=carpeta.Nombre;
            this.datosBusquedaXCliente.CodigoUnidad=a.Codigo
            this.actasService.getArchivosXCliente(this.datosBusquedaXCliente).subscribe(
                listado => {
                    this.archivosXCliente = listado;
                    this.archivosXCliente.forEach(a => {
                        if (a.Extension == "pdf")
                            a.TipoIcono = "fa-file-pdf-o";
        
                        if (a.Extension == "xls" || a.Extension == "xlsx")
                            a.TipoIcono = " fa-file-excel-o";
        
                        else
                            a.TipoIcono = "fa-file-text-o";
                    });
                    this.showLoader = "";                
                },
                error => {
                    this.handleError.redirectUrl(error);
                    this.showLoader = "";
                });
        }
        
    });
    
    
}
    descargar(archivo: Archivo) {
        this.showLoader = "sk-loading";
        this.actasService.getArchivo(archivo).subscribe(
            result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = null;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    blob = new Blob([fileBlob], {
                        type: 'application/pdf'
                    });
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                }
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    a.download = archivo.Nombre + ".pdf";
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    a.download = archivo.Nombre + ".xlsx";
                }
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if (archivo.Extension.toUpperCase() == "XLSX") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".xlsx");
                    } else {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".pdf");
                    }
                }
                else {
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/actas/actas.component.ts